import { render } from "./SubscriptionTransactionsPage.vue?vue&type=template&id=281f6f96"
import script from "./SubscriptionTransactionsPage.vue?vue&type=script&lang=ts"
export * from "./SubscriptionTransactionsPage.vue?vue&type=script&lang=ts"

import "./SubscriptionTransactionsPage.vue?vue&type=style&index=0&id=281f6f96&lang=scss"
script.render = render

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip,QSelect,QField});
